<template>
    <g v-if="show">
        <chart-segment v-if="type === 'segment'" v-for="(value, index) in lineValues" v-bind="value" :index="index" :key="'segment-' + index"  :color="color"></chart-segment>
        <chart-node v-if="type === 'node'" v-for="(year, index) in years" :value="valuesPerYear[+year]" :year="year" :index="index" :key="'node-'+index" :color="color"></chart-node>
    </g>
</template>

<script lang="ts">
    import ChartNode from './chart-category/chart-node.vue';
    import ChartSegment from './chart-category/chart-segment.vue';
    import _ from 'lodash';
    import {defineComponent} from 'vue';
    import {Line} from "./types";
    
    export default defineComponent({
            name: 'chart-category',
            props: {
                isActive: Boolean,
                valuesPerYear: Object as () => Record<number, number>,
                label: String,
                color: String,
                hasNoValues: Boolean,
                type: String,
                years: Array as () => string[]
            },
            components: {
                'chart-node': ChartNode,
                'chart-segment': ChartSegment
            },
            computed: {
                show():boolean {
                    return this.isActive && !this.hasNoValues;
                },
                lineValues(): Line[] {
                    let valStart = 0;
                    let valEnd = 0;
                    let lines = [] as Line[];

                    _.forEach(this.years, (year: string) => {
                        const val = this.valuesPerYear![+year];
                        
                        if (valStart === 0)
                            valStart = val;
                        else if (valEnd === 0)
                            valEnd = val;

                        if (valStart !== 0 && valEnd !== 0) {
                            let line: Line = {
                                valStart: valStart,
                                valEnd: valEnd,
                                year: +year
                            };

                            lines.push(line);
                            valStart = val;
                            valEnd = 0;
                        }
                    });

                    return lines;
                }
            }
        });
</script>
